module.exports = __webpack_public_path__ + "media/images/social_icons/twitter_square-9fde1d22ee78fcebd7e55b89bffabe59.png";